import wcbtCompareList from './compare-product/compare-list';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	wcbtCompareList();
} );
